module.exports = __webpack_public_path__ + "na.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/na.svg
// module id = 721
// module chunks = 0